import { createContext } from "react";

export const SlideinStore = createContext({
    currentSlidein: {
        action:"",
        actionURL:"",
        urlPramas : {}
    },
    setCurrentSlideIn: () => {}
});